import { RequestStatus } from 'legacy/lut/configs/service'
import { useRef } from 'react'
import { useSelector } from 'react-redux'

import type { CardTone } from 'partner360/components/card'

import {
  selectFinancialCockpitState,
  selectIsCockpitOfferingSwitchedOff,
  selectIsCockpitPlanningStarted,
} from '../../../model/selectors'

import { useHasAttentionStatuses } from './useHasAttentionStatuses'

/**
 * The tile's card tone: green once the cockpit has loaded and raised nothing, so a clean scope is
 * told by the card itself. While the data is still on its way, while nothing in view is planned
 * yet, and on a programme switched off for the partner — nothing raised is not a clean plan then:
 * nothing is calculated for it — the card stays neutral. While another year loads over the board
 * the card keeps its tone, so it does not blink to neutral and back.
 */
export const useAttentionTileTone = (isManagerCockpitMode: boolean): CardTone => {
  const { fetchingStatus } = useSelector(selectFinancialCockpitState)
  const hasStatuses = useHasAttentionStatuses(isManagerCockpitMode)
  const isPlanningStarted = useSelector(selectIsCockpitPlanningStarted)
  const isSwitchedOff = useSelector(selectIsCockpitOfferingSwitchedOff)

  const toneRef = useRef<CardTone>('neutral')

  if (fetchingStatus !== RequestStatus.PENDING) {
    toneRef.current =
      fetchingStatus === RequestStatus.FULFILLED &&
      !hasStatuses &&
      isPlanningStarted &&
      !isSwitchedOff
        ? 'success'
        : 'neutral'
  }

  return toneRef.current
}
